import { render, staticRenderFns } from "./personOpen.vue?vue&type=template&id=1f5b95fc&scoped=true&"
import script from "./personOpen.vue?vue&type=script&lang=js&"
export * from "./personOpen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5b95fc",
  null
  
)

export default component.exports